var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75C13.5564 0.75 17.25 4.44365 17.25 9C17.25 13.5564 13.5564 17.25 9 17.25C4.44365 17.25 0.75 13.5564 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM7.125 5.75195C7.35695 5.61813 7.64305 5.61813 7.875 5.75195L12.375 8.35059C12.607 8.48457 12.75 8.73207 12.75 9C12.75 9.26793 12.607 9.51544 12.375 9.64941L7.875 12.248C7.64305 12.3819 7.35695 12.3819 7.125 12.248C6.89295 12.1141 6.75 11.8656 6.75 11.5977V6.40234C6.75 6.13439 6.89295 5.88593 7.125 5.75195ZM8.25 10.2988L10.5 9L8.25 7.70117V10.2988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c6ec5f86eafe917ce68e7e658680f624.svg";
export { ForwardRef as ReactComponent };